// Copyright (c) 2020 Comsearch, Inc., All rights reserved

const columns = [{
  columnKey: 'rcnNumber',
  columnHeader: 'RCN',
  sortable: true,
}, {
  columnKey: 'jobCode',
  columnHeader: 'Job Number',
  sortable: true,
}, {
  columnKey: 'serviceContactCodes',
  columnHeader: 'Contact Code',
  sortable: true,
}, {
  columnKey: 'rcnStatusCode',
  columnHeader: 'RCN Status',
  sortable: true,
}]

export default columns
